export function identificarDispositivoNativo() {
	const hasIOSBridge = !!window?.webkit?.messageHandlers?.iOSInterface
	const hasAndroidInterface = !!window?.AndroidInterface
	const userAgent = window?.navigator?.userAgent ?? ""
	const hasIOSUserAgent = /iPad|iPhone|iPod|iOS/i.test(userAgent)

	if (hasIOSBridge || hasIOSUserAgent)
		return "iOS"

	if (hasAndroidInterface)
		return "Android"

	return null
}
